<div class="container">
    <div class="row mt-4">
        <div class="col-7">
            <h4>Lista de Fórmulas - {{form?.name}}</h4>
        </div>
        <div class="col-5 text-right">
            <button class="btn btn-primary col-5 mr-1" (click)="goNewFormule()" *ngIf="isUserDev">Nova Formula</button>
            <button class="btn btn-secondary col-5" (click)="backList()">Voltar</button>
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12 text-center" *ngIf="formuleList.length === 0">
            <label for="">Nenhum registro encontrado</label>
        </div>
        <div class="col-12">
            <div class="accordion">

                <div class="card" *ngFor="let item of formuleList; let i = index">
                    <div class="card-header" id="f_{{i}}">
                        <div class="row">
                            <div class="col-5">
                                <h2 class="mb-0">
                                    <button class="btn btn-link btn-block text-left" type="button"
                                        data-toggle="collapse" data-target="#f_{{i}}" aria-expanded="true"
                                        aria-controls="f_{{i}}" (click)="openFormule(i)">
                                        {{item.name}}
                                    </button>
                                </h2>
                            </div>
                            <div class="col-2 mt-2 text-right">
                                <span *ngIf="item.is_front" class="badge badge-info">FRONT</span>
                                <span *ngIf="item.is_trigger" class="badge badge-info ml-2">TRIGGER</span>
                            </div>
                            <div class="col-4 mt-2 text-right">
                                Última modificação: {{item.updated_at | date: 'dd/MM/yyyy'}}
                            </div>
                            <div class="col-1 text-right" *ngIf="isUserDev">
                                <button mat-icon-button [matMenuTriggerFor]="menu"
                                    aria-label="Example icon-button with a menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">

                                    <button mat-button color="primary" class="w-100" matTooltip="Editar Fórmula"
                                        (click)="goEditFormule(item.id)">
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar Fórmula
                                    </button>

                                    <button mat-button color="warn" class="w-100" matTooltip="Editar Fórmula"
                                        (click)="showDeleteFormule(item.id)">
                                        <i class="fa fa-remove fa-1x btnIcon"></i>
                                        Excluir Fórmula
                                    </button>

                                </mat-menu>
                            </div>
                        </div>
                    </div>

                    <div id="collapse_{{i}}" class="collapse" aria-labelledby="f_{{i}}" data-parent="#f_{{i}}">
                        <div class="card-body" [innerHtml]="item.description">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>